<template>
  <div class="page-report">
    <HeaderMegaposData/>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Modifier Sales by All Items</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :totalDaySelect="60"
              @reload-data="getList(page)"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-6"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input
                          type="search"
                          v-model="searchKeyword"
                          @input="onKeywordSearch"
                        />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <div class="table-container">
                        <table
                          class="table align-items-center mb-0 dataTable"
                          ref="dataTable"
                        >
                          <thead>
                            <tr>
                              <th class="text-center font-weight-bolder">
                                <div class="pt-1">Item Name</div>
                              </th>
                              <th
                                v-for="modifier in items.modifier_columns"
                                :key="modifier.item_no"
                                class="text-center font-weight-bolder"
                              >
                                <div class="pt-1">{{ modifier.item_no }} <br> {{ modifier.item_name }}</div>
                              </th>
                            </tr>
                            <tr>
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[0]"
                                  @input="searchColumn(0)"
                                />
                              </th>
                              <th
                                v-for="(modifier, index) in items.modifier_columns"
                                :key="modifier.item_no"
                                class="text-center font-weight-bolder"
                              >
                                <input
                                  v-model="columnSearch[index + 1]"
                                  @input="searchColumn(index + 1)"
                                />
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="items.matrix_data && items.matrix_data.length">
                            <tr v-for="(item, index) in items.matrix_data" :key="item.item_no" :class="{ 'bg-gray-50': index % 2 === 0 }" @click="viewDetail(item)">
                              <td class="text-left text-xss">
                                {{ item.item_no }} / {{ item.item_name }}
                              </td>
                              <td
                                v-for="modifier in items.modifier_columns"
                                :key="modifier.item_no"
                                class="text-center text-xss"
                              >
                                {{ item.modifiers[modifier.item_no] || 0 }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td :colspan="1 + items.modifier_columns.length" class="text-left">
                                No matching records found
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="total-row">
                              <td class="text-left text-xss">TOTAL</td>
                              <td
                                v-for="modifier in items.modifier_columns"
                                :key="'tf-' + modifier.item_no"
                                class="text-center text-xss"
                              ></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/item-sales-modifiers-new/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="item_no" :value="form.item_no" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
    <ModalItemModifierDetail
      :keyReload="keyReload"
      :idSelected="idSelected"
      :form="form"
      :isEdit="true"
      @reload-data="reloadData"
    ></ModalItemModifierDetail>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import "datatables.net";
import Pagination from '@/components/Pagination.vue'
import FormSearch from "./components/FormSearch.vue";
import ModalItemModifierDetail from "./components/ModalItemModifierDetail.vue";
import HeaderMegaposData from "./components/HeaderMegaposData.vue";

export default {
  name: "ItemSalesModifiersReportNew",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    ModalItemModifierDetail,
    HeaderMegaposData,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      items: {
        matrix_data: [],
        modifier_columns: []
      },
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
        item_no: "",
      },
      idSelected: {
        item_no: '',
        item_name: ''
      },
      keyReload: 0,
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      dataTable: null,
      tableData: [],
      columnSearch: [],
      pagination: {},
      page: 1,
      totalItemTotal: 0,
      loadingTimeout: null,
      searchKeyword: "",
    };
  },
  methods: {
    viewDetail(item) {
      this.idSelected = {
        item_no: item.item_no,
        item_name: item.item_name
      };
      this.form.item_no = item.item_no;

      this.keyReload = Math.random();
      $(".show-modal-item-modifier-detail").click();
    },
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      return (
        "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
      }

      const self = this;
      this.$nextTick(() => {
        this.dataTable = $(this.$refs.dataTable).DataTable({
          paging: false,
          searching: true,
          ordering: false,
          info: false,
          // Render only the table (no built-in search/length/info controls) — the
          // custom "Search:" box above drives the search, so this avoids a duplicate.
          dom: "t",
          // Total row = sum of each modifier column, recomputed from the rows that
          // match the current search (mirrors POS Daily Collection / channel).
          footerCallback: function () {
            const api = this.api();
            const footer = $(api.table().footer());
            if (!footer.length) return;
            const cells = footer.find("td");

            const parseNum = (v) => {
              const n = parseInt(String(v).replace(/[^0-9-]/g, ""), 10);
              return isNaN(n) ? 0 : n;
            };
            const colCount = self.items.modifier_columns.length;
            for (let c = 1; c <= colCount; c++) {
              const sum = api
                .column(c, { search: "applied" })
                .data()
                .reduce((acc, val) => acc + parseNum(val), 0);
              cells.eq(c).html(sum);
            }
          },
        });
      });
    },

    searchColumn(index) {
      if (!this.dataTable) {
        console.warn('DataTable not initialized');
        return;
      }
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    onKeywordSearch() {
      // Global search across the whole (client-side) matrix; the footer total
      // recomputes from the matching rows on draw.
      if (!this.dataTable) return;
      this.dataTable.search(this.searchKeyword).draw();
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      if (this.items.matrix_data && this.items.matrix_data.length) {
        this.getList(this.page, true);
      }
    },

    reloadData() {
      this.getList(this.page);
    },

    showLoader() {
      this.loaderActive = true;
      // Set timeout to prevent infinite loading
      this.loadingTimeout = setTimeout(() => {
        this.hideLoader();
        this.showError('Request timeout. Please try again.');
      }, 30000); // 30 seconds timeout
    },

    hideLoader() {
      this.loaderActive = false;
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
    },

    showError(message) {
      this.snackbar = "danger";
      this.message = message;
      this.setTimeOutNotification();
    },

    getList(page, isSort = false) {
      if (!isSort) {
        this.isLoadDone = false;
        this.isLoadDoneDataTable = false;
      }

      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        item_no: this.form.item_no,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
        page: page,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
      };

      AnalyticsService.itemSalesModifiersReportNew(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const responseData = response.data.data;
            this.items = {
              matrix_data: responseData.matrix_data || [],
              modifier_columns: responseData.modifier_columns || []
            };

            const totalColumn = this.items.modifier_columns.length;
            this.columnSearch = [""];
            for (let i = 0; i < totalColumn; i++) {
              this.columnSearch.push("");
            }

            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
          } else {
            this.showError(response.data.result.message || 'Failed to load data');
          }
          this.hideLoader();
        },
        (error) => {
          console.error('API Error:', error);
          this.showError(error?.response?.data?.message || 'An error occurred while loading data');
          this.hideLoader();
        }
      );
    },
  },
  beforeUnmount() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        this.$nextTick(() => {
          this.initializeDataTable();
        });
      }
    },
  },
};
</script>
<style scoped>
.custom-table {
  position: relative;
}

.table-container table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

/* Fix first column when scrolling horizontally */
.table-container th:first-child,
.table-container td:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  background: white;
}

/* Add shadow effects */
.table-container th:first-child,
.table-container td:first-child {
  box-shadow: 2px 0 2px -1px rgba(0, 0, 0, 0.1);
}

/* Cell styles */
.table-container th,
.table-container td {
  padding: 3px 6px !important;
  border: 1px solid #dee2e6;
  white-space: nowrap;
}

/* Alternating row colors */
.table-container tbody tr:nth-child(odd) {
  background-color: #f8f9fa;
}

.table-container tbody tr:nth-child(even) {
  background-color: #ffffff;
}

/* Hover effect */
.table-container tbody tr:hover {
  background-color: #e9ecef !important;
}

/* Ensure first column background matches row color */
.table-container tbody tr:nth-child(odd) td:first-child {
  background-color: #f8f9fa;
}

.table-container tbody tr:nth-child(even) td:first-child {
  background-color: #ffffff;
}

.table-container tbody tr:hover td:first-child {
  background-color: #e9ecef !important;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

/* Total row */
tfoot tr.total-row {
  font-weight: bold;
  color: #222;
  background: #e9edf2;
}

.table-container tfoot tr.total-row td {
  border-top: 2px solid #dee2e6;
  background: #e9edf2;
}

/* Column search inputs, styled like POS Daily Collection */
.table-container table.dataTable thead th input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  color: #495057;
  font-weight: normal;
}

.table-container table.dataTable thead th input:focus {
  outline: none;
  border-color: #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}
</style>
